@if (control) {
  <astral-input [control]="control" [helpText]="helpText" [placeholderText]="format | translate"></astral-input>
}
